export default ({ route, store }) => {
  const meta = route.meta.reduce((acc, item) => ({ ...acc, ...item }), {})
  store.dispatch(`navigation/setMeta`, { meta })
}
